import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateArrayPipe } from './translate-array.pipe';
import { TranslateArrayService } from './translate-array.service';

@NgModule({
  declarations: [TranslateArrayPipe],
  exports: [TranslateArrayPipe],
  imports: [TranslateModule],
  providers: [TranslateArrayService]
})
export class TranslateArrayModule { }
